import { Injectable } from '@angular/core';
import { Model } from 'survey-core';
import * as Survey from 'survey-core';
import {
  ApplicationsApiService,
  SnackbarService,
  ProductTypeCatalogApiService,
  OfficesApiService,
  CategoriesApiService,
  FindPersonApiService,
  PeopleApiService,
  PeopleLookupApiService,
  NrdsMembersApiService
} from '@tangilla/tg-ng-core';
import { of, switchMap } from 'rxjs';
import { SurveyUtilsService } from '../utils/survey.utils.service';
import { ApplicationForm } from '../utils/application-form';
import { SurveyService } from 'src/app/core/services/survey/survey.service';
import { RequestParameters } from '@tangilla/tg-ng-models';
import { ErrorsService } from 'src/app/core/services/utils/errors.service';
import { DetailsListWidgetService } from '../../widgets/details-list/services/details-list.widget.service';
import {
  ApplicationChargesUtilsService
} from '../../../../core/services/utils/charges/application-charges.utils.service';


@Injectable({
  providedIn: 'root'
})
export class AffiliateApplicationService extends ApplicationForm {

  constructor(
    override officesApiService: OfficesApiService,
    protected categoriesApiService: CategoriesApiService,
    override applicationsService: ApplicationsApiService,
    override snackbarService: SnackbarService,
    override productTypeCatalogService: ProductTypeCatalogApiService,
    override chargesUtils: SurveyUtilsService,
    override surveyService: SurveyService,
    override peopleApiService: PeopleApiService,
    override peopleLookupService: PeopleLookupApiService,
    override errorsService: ErrorsService,
    private findPersonApiService: FindPersonApiService,
    private nrdsMembersApiService: NrdsMembersApiService,
    override detailsListWidgetService: DetailsListWidgetService,
    override applicationChargesUtilsService: ApplicationChargesUtilsService,
  ) {
    super(applicationsService, productTypeCatalogService, snackbarService, chargesUtils, surveyService, peopleApiService, peopleLookupService, errorsService, officesApiService, detailsListWidgetService, applicationChargesUtilsService);
  }

  override initializeForm(): any {

    super.initializeForm();

    const office_search_state_q = this.surveyService.surveyModel.getQuestionByName('Office-Search-State');
    if (office_search_state_q) {
      office_search_state_q.value = this.surveyService.surveyModel.getVariable('v-state');
    }

    // // Here goes the navigation code for the membership application form
    // this.initializeOnAfterRenderPage();
    // this.initializeOnCurrentPageChanging();
    // this.initializeOnValueChanged();

  }

  // override setFormOnComplete() {
  //   const that = this;

  //   this.surveyService.surveyModel.onComplete.add(function (result) {
  //   });
  // }

  override initializeOnAfterRenderPage() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch (currentPage.name) {
        case 'Confirmation':
          this.buildOrderConfirmation();
          break;
        case 'AffiliateCategory':
          this.loadAffiliateCategories();
          break;
      }
    });
  }

  override initializeOnCurrentPageChanging() {
    this.surveyService.surveyModel.onCurrentPageChanging.add((sender, options) => {
      if (options.oldCurrentPage !== null) {
        const thisPageName = options.oldCurrentPage.name;
        switch (thisPageName) {
          case 'Your Office':
            if (sender.getQuestionByName('office').isEmpty() && sender.getValue('Office-Search-Type') !== 'NewOffice' && options.isNextPage) {
              this.errorsService.exitForm('No Office Available to be Selected', 'No office was available to be selected based on the information provided. Please try again later or contact support.');
            }
            break;
          case 'AffiliateCategory':
            of(null).pipe(
              switchMap(() => this.setRoleAndFetchProducts())
            ).subscribe({
              next: () => {
                if (this.surveyService.surveyModel.getValue('role')) {
                  this.setPricingTable();
                }
              },
              error: (error) => {
                this.errorsService.processError(error);
              }
            });
        }
      }
    });
  }

  override initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
      if (options.name === 'office') {
        const officeIdSelected = sender.getValue('office');
        if (officeIdSelected) {
          this.surveyService.isLoading = true;
          this.officesApiService.getOffice(officeIdSelected).subscribe({
            next: (office: any) => {
              sender.setVariable('selected_office', office);
              sender.setVariable('office_name', office.business_name);
              sender.setVariable('dr_name', office.field_description.designated_realtor);
              this.surveyService.isLoading = false;
            },
            error: (error) => {
              this.surveyService.isLoading = false;
              this.errorsService.processError(error, 'soft');
            }
          });
        }
      } else if (options.name == 'field_of_business' && this.surveyService.surveyModel.getValue('field_of_business')) {
        this.getOccupations();
      } else if (options.name === 'LicenseHeld') {
        if (this.surveyService.surveyModel.getValue('LicenseHeld') === 'Yes') {
          this.surveyService.surveyModel.setValue('field_of_business', '432');
          this.getOccupations();
        }
      } else if (options.name === 'NRDS') {
        // Find person by nrds id
        if (options.value) {
          const requestParameters = new RequestParameters(null);
          requestParameters.additionalFields = {
            member_nrds_id: options.value
          };
          this.surveyService.isLoading = true;
          this.findPersonApiService.get(requestParameters).subscribe({
            next: (response: any) => {
              if (response.length > 0) {
                this.setPersonId(response[0].person_id);
              } else {
                this.setPersonId(null);
              }

              // Check for StateDuesStatus question value
              const parameters = (new RequestParameters(null)).setAdditionalFields({member_nrds_id: options.value});
              this.nrdsMembersApiService.get(parameters)
                .subscribe({
                  next: (response: any) => {
                    const duesStatus = response[0].state_association_id !== this.surveyService.surveyModel.getVariable('v-state_nrds') ? 'O' : 'S';
                    this.surveyService.surveyModel.setValue('StateDuesStatus', duesStatus);
                    this.surveyService.isLoading = false;
                  },
                  error: (error: any) => {
                    this.surveyService.isLoading = false;
                    this.errorsService.processError(error);
                  }
                });

            },
            error: (error: any) => {
              this.surveyService.isLoading = false;
              this.setPersonId(null);
              if (error.error && error.error.status !== 404) {
                this.errorsService.processError(error);
              }
            }
          });
        }
      }

    });
  }

  setFormOnCompleting(surveyModel: Model) {
    const that = this;

    surveyModel.onCompleting.add(async function (survey, options) {

    });
  }

  private loadAffiliateCategories() {
    this.surveyService.isLoading = true;
    this.categoriesApiService.getAll()
      .subscribe({
        next: (response: any) => {
          const categories = response.items;
          const question = this.surveyService.surveyModel.getQuestionByName('field_of_business');
          question['choices'].splice(0, question['choices'].length);
          this.surveyService.surveyModel.setVariable('categories', categories);
          for (const category of categories) {
            let item = new Survey.ItemValue(category.category_id, category.name);
            question['choices'].push(item);
          }
          this.surveyService.isLoading = false;
        },
        error: (error: any) => {
          this.surveyService.isLoading = false;
          this.errorsService.processError(error);
        }
      });
  }

  private getOccupations() {
    const occupationQuestion = this.surveyService.surveyModel.getQuestionByName('occupation');
    const fieldOfBusinessQuestion = this.surveyService.surveyModel.getQuestionByName('field_of_business');
    const fieldOfBusinessSelected = fieldOfBusinessQuestion.value;
    if (fieldOfBusinessSelected) {
      occupationQuestion['choices'].splice(0, occupationQuestion['choices'].length); // clear existing options from the occupation question
      const categories = this.surveyService.surveyModel.getVariable('categories');
      if (categories) {
        const category = categories.find((c: any) => c.category_id === fieldOfBusinessSelected);
        const key_services = category.key_services;
        this.surveyService.surveyModel.setVariable('key_services', key_services);
        this.surveyService.surveyModel.setValue('field_of_business_code', category.nar_fob_code);
        this.surveyService.isLoading = true;
        this.categoriesApiService.getOccupations(fieldOfBusinessSelected)
          .subscribe({
            next: (response: any) => {
              const occupations = response.items;
              for (const occupation of occupations) {
                const item = new Survey.ItemValue(occupation.name, occupation.name);
                occupationQuestion['choices'].push(item);
              }
              this.surveyService.isLoading = false;
            },
            error: (error: any) => {
              this.surveyService.isLoading = false;
              this.errorsService.processError(error);
            }
          });
      } else {
        this.surveyService.surveyModel.setVariable('key_services', false);
        this.surveyService.surveyModel.setValue('field_of_business_code', null);
        this.surveyService.isLoading = false;
      }
    }

  }

}
